import { createContext } from "react";

const StudyMaterialContext = createContext();

export default StudyMaterialContext;